//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const SERVICES_LOANS_API_BASE_URL = new InjectionToken<string>('SERVICES_LOANS_API_BASE_URL');

export interface IServicesLoansApiService {
    /**
     * Retrieves the application's status.
     * @return OK
     */
    getApplicationStatus(applicationId: string): Observable<ApplicationStatusResponse>;
    /**
     * @return Success
     */
    checkEligibility(body: MortgageCalculatorRequest): Observable<MortgageCalculatorResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ServicesLoansApiService implements IServicesLoansApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(SERVICES_LOANS_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves the application's status.
     * @return OK
     */
    getApplicationStatus(applicationId: string): Observable<ApplicationStatusResponse> {
        let url_ = this.baseUrl + "/applications/{applicationId}/status";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationStatusResponse>;
        }));
    }

    protected processGetApplicationStatus(response: HttpResponseBase): Observable<ApplicationStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    checkEligibility(body: MortgageCalculatorRequest): Observable<MortgageCalculatorResponse> {
        let url_ = this.baseUrl + "/mortgage-calculator/check-eligibility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckEligibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckEligibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MortgageCalculatorResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MortgageCalculatorResponse>;
        }));
    }

    protected processCheckEligibility(response: HttpResponseBase): Observable<MortgageCalculatorResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MortgageCalculatorResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ApplicationStatusResponse implements IApplicationStatusResponse {
    applicationId?: string | undefined;
    status?: PlatformStatus;

    constructor(data?: IApplicationStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ApplicationStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["status"] = this.status;
        return data;
    }
}

export interface IApplicationStatusResponse {
    applicationId?: string | undefined;
    status?: PlatformStatus;
}

export class Financialinfo implements IFinancialinfo {
    familyIncome?: number;
    totalDebt?: number;
    totalTaxValue?: number;
    underageKidsNumber?: number;

    constructor(data?: IFinancialinfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.familyIncome = _data["familyIncome"];
            this.totalDebt = _data["totalDebt"];
            this.totalTaxValue = _data["totalTaxValue"];
            this.underageKidsNumber = _data["underageKidsNumber"];
        }
    }

    static fromJS(data: any): Financialinfo {
        data = typeof data === 'object' ? data : {};
        let result = new Financialinfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["familyIncome"] = this.familyIncome;
        data["totalDebt"] = this.totalDebt;
        data["totalTaxValue"] = this.totalTaxValue;
        data["underageKidsNumber"] = this.underageKidsNumber;
        return data;
    }
}

export interface IFinancialinfo {
    familyIncome?: number;
    totalDebt?: number;
    totalTaxValue?: number;
    underageKidsNumber?: number;
}

export class GuarantorInfo implements IGuarantorInfo {
    debt?: number;
    birthYearOfGuarantor?: number;
    income?: number;
    taxValue?: number;
    underageKidsNumber?: number;
    maritalStatus?: string | undefined;

    constructor(data?: IGuarantorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.debt = _data["debt"];
            this.birthYearOfGuarantor = _data["birthYearOfGuarantor"];
            this.income = _data["income"];
            this.taxValue = _data["taxValue"];
            this.underageKidsNumber = _data["underageKidsNumber"];
            this.maritalStatus = _data["maritalStatus"];
        }
    }

    static fromJS(data: any): GuarantorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new GuarantorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["debt"] = this.debt;
        data["birthYearOfGuarantor"] = this.birthYearOfGuarantor;
        data["income"] = this.income;
        data["taxValue"] = this.taxValue;
        data["underageKidsNumber"] = this.underageKidsNumber;
        data["maritalStatus"] = this.maritalStatus;
        return data;
    }
}

export interface IGuarantorInfo {
    debt?: number;
    birthYearOfGuarantor?: number;
    income?: number;
    taxValue?: number;
    underageKidsNumber?: number;
    maritalStatus?: string | undefined;
}

export class HttpValidationProblemDetails implements IHttpValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

export interface IHttpValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;
}

export class Loaninfo implements ILoaninfo {
    amount?: number;
    categoryId?: string | undefined;
    duration?: number;
    interestRate?: string | undefined;
    realEstateValue?: number;
    fixedInterestRate?: number;

    constructor(data?: ILoaninfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.categoryId = _data["categoryId"];
            this.duration = _data["duration"];
            this.interestRate = _data["interestRate"];
            this.realEstateValue = _data["realEstateValue"];
            this.fixedInterestRate = _data["fixedInterestRate"];
        }
    }

    static fromJS(data: any): Loaninfo {
        data = typeof data === 'object' ? data : {};
        let result = new Loaninfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["categoryId"] = this.categoryId;
        data["duration"] = this.duration;
        data["interestRate"] = this.interestRate;
        data["realEstateValue"] = this.realEstateValue;
        data["fixedInterestRate"] = this.fixedInterestRate;
        return data;
    }
}

export interface ILoaninfo {
    amount?: number;
    categoryId?: string | undefined;
    duration?: number;
    interestRate?: string | undefined;
    realEstateValue?: number;
    fixedInterestRate?: number;
}

export class MortgageCalculatorRequest implements IMortgageCalculatorRequest {
    loanInfo?: Loaninfo | undefined;
    personalInfo?: Personalinfo | undefined;
    financialInfo?: Financialinfo | undefined;
    hasGuarantor?: boolean;
    guarantor?: GuarantorInfo | undefined;

    constructor(data?: IMortgageCalculatorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanInfo = _data["loanInfo"] ? Loaninfo.fromJS(_data["loanInfo"]) : <any>undefined;
            this.personalInfo = _data["personalInfo"] ? Personalinfo.fromJS(_data["personalInfo"]) : <any>undefined;
            this.financialInfo = _data["financialInfo"] ? Financialinfo.fromJS(_data["financialInfo"]) : <any>undefined;
            this.hasGuarantor = _data["hasGuarantor"];
            this.guarantor = _data["guarantor"] ? GuarantorInfo.fromJS(_data["guarantor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MortgageCalculatorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MortgageCalculatorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanInfo"] = this.loanInfo ? this.loanInfo.toJSON() : <any>undefined;
        data["personalInfo"] = this.personalInfo ? this.personalInfo.toJSON() : <any>undefined;
        data["financialInfo"] = this.financialInfo ? this.financialInfo.toJSON() : <any>undefined;
        data["hasGuarantor"] = this.hasGuarantor;
        data["guarantor"] = this.guarantor ? this.guarantor.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMortgageCalculatorRequest {
    loanInfo?: Loaninfo | undefined;
    personalInfo?: Personalinfo | undefined;
    financialInfo?: Financialinfo | undefined;
    hasGuarantor?: boolean;
    guarantor?: GuarantorInfo | undefined;
}

export class MortgageCalculatorResponse implements IMortgageCalculatorResponse {
    isEligible?: boolean;
    amount?: number;

    constructor(data?: IMortgageCalculatorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEligible = _data["isEligible"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): MortgageCalculatorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MortgageCalculatorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEligible"] = this.isEligible;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IMortgageCalculatorResponse {
    isEligible?: boolean;
    amount?: number;
}

export class Personalinfo implements IPersonalinfo {
    birthYear?: number;
    isCustomer?: boolean | undefined;
    maritalStatus?: string | undefined;
    underageKidsNumber?: number;
    email?: string | undefined;

    constructor(data?: IPersonalinfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.birthYear = _data["birthYear"];
            this.isCustomer = _data["isCustomer"];
            this.maritalStatus = _data["maritalStatus"];
            this.underageKidsNumber = _data["underageKidsNumber"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): Personalinfo {
        data = typeof data === 'object' ? data : {};
        let result = new Personalinfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["birthYear"] = this.birthYear;
        data["isCustomer"] = this.isCustomer;
        data["maritalStatus"] = this.maritalStatus;
        data["underageKidsNumber"] = this.underageKidsNumber;
        data["email"] = this.email;
        return data;
    }
}

export interface IPersonalinfo {
    birthYear?: number;
    isCustomer?: boolean | undefined;
    maritalStatus?: string | undefined;
    underageKidsNumber?: number;
    email?: string | undefined;
}

export enum PlatformStatus {
    Unspecified = "Unspecified",
    Abandoned = "Abandoned",
    Approved = "Approved",
    Disbursement = "Disbursement",
    InProgress = "InProgress",
    PreApproved = "PreApproved",
    Rejected = "Rejected",
    Signed = "Signed",
    Submitted = "Submitted",
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}